export const ACCESS_TOKEN_COOKIE_KEY = 'coachAccessToken';
export const ADMIN_ACCESS_TOKEN_COOKIE_KEY = 'adminAccessToken';
export const ADMINS_COACH_ID_COOKIE_KEY = 'adminsCoachId';
